import { render, staticRenderFns } from "./taskTemplateAdd.vue?vue&type=template&id=f91a3572&"
import script from "./taskTemplateAdd.vue?vue&type=script&lang=js&"
export * from "./taskTemplateAdd.vue?vue&type=script&lang=js&"
import style0 from "./taskTemplateAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports